import React from "react";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";

function BillRateTable({ tableData, isLoading }) {
  const navigate = useNavigate();

  const handleEditClick = (rowData) => {
    // Pass the row data via navigation state
    navigate(`/home/billing/bill-rate-edit/${rowData.id}`, {
      state: { billRateData: rowData },
    });
  };

  // Format currency
  const formatCurrency = (value) => {
    if (!value && value !== 0) return "$0.00";
    return `$${parseFloat(value).toFixed(2)}`;
  };

  return (
    <Table striped bordered hover className="tbl-require">
      <thead>
        <tr>
          <th>#</th>
          <th>Service Name</th>
          <th>Service Codes</th>
          <th>Payor</th>
          <th>State</th>
          <th>Base Rate</th>
          <th>Mileage Rate</th>
          <th style={{ textAlign: "center" }}>Action</th>
        </tr>
      </thead>
      <tbody>
        {tableData && tableData.length > 0 ? (
          tableData.map((details, index) => (
            <tr key={details.id || index}>
              <td>{index + 1}</td>
              <td>{details?.serviceDetails?.service_name || "N/A"}</td>
              <td>
              <small style={{ fontSize: "13px", fontWeight: "600" }}>Base Code:</small>
              <small
                  style={{
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#0047AB",
                  }}
                >
                  {details?.serviceDetails?.base_code || "N/A"} {details?.serviceDetails?.modifier ?? ''}
                </small>
                <br />
                <small style={{ fontSize: "13px", fontWeight: "600" }}>Mileage Code:</small>
                <small
                  style={{
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#0047AB",
                  }}
                >
                  {details?.serviceDetails?.milage_code || "N/A"} {details?.serviceDetails?.milage_modifier ?? ''}
                </small>
              </td>
              <td>{details?.payerDetails?.payer_name || "N/A"}</td>
              <td>
                {details?.stateDetails?.state_name || details?.state || "N/A"}
              </td>
              <td>{formatCurrency(details?.base_bill_rate)}</td>
              <td>{formatCurrency(details?.mileage_bill_rate)}</td>
              <td style={{ textAlign: "center", cursor: "pointer" }}>
                <i
                  className="pi pi-pen-to-square icon-btn-edit"
                  onClick={() => handleEditClick(details)}
                  title="Edit"
                ></i>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="8" style={{ textAlign: "center", padding: "20px" }}>
              {isLoading ? "Loading..." : "No bill rate configurations found"}
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
}

export default BillRateTable;
